import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  state: { // 设置属性
    openmall: false, // 开放商城
    requireAuth: false, // 是否登录
    breadListState:[{name:'首页',path:'/'}],
    themecolor: '#5B5FC2', // 主题色
    shopcartlist: [], // 购物车列表
    goodsBrowsingHistory: '', // 商品浏览记录，只保存id
  },
  getters: { // 获取属性的状态
    openmall: state => state.openmall,
    requireAuth: state => state.requireAuth,
    themecolor: state => state.themecolor,
    shopcartlist: state => state.shopcartlist,
    goodsBrowsingHistory: state => state.goodsBrowsingHistory,
    shopcartlist: state => state.shopcartlist,
  },
  mutations: { // 设置属性状态
    openmallChange (state, sign) {
      state.openmall = sign
    },
    requireAuthChange (state, sign) {
      state.requireAuth = sign
    },
    // 面包屑
    breadListStateAdd (state, obj) {
      state.breadListState.push(obj)
    },
    breadListStateRemove(state, num){
      state.breadListState=state.breadListState.slice(0, num)
    },
    sethemecolor (state, color) { // 设置主题色
      state.themecolor = color
    },
    setgoodsid (state, id) { // 添加商品浏览记录
      let arr = []
      if (state.goodsBrowsingHistory != '') arr = state.goodsBrowsingHistory.split(',')
      if (arr.indexOf(id) == -1) {
        arr.unshift(id)
      } else {
        arr.splice(arr.indexOf(id), 1)
        arr.unshift(id)
      }
      // if (arr.length > 8) arr.pop()
      state.goodsBrowsingHistory = arr.join(',')
    },
    setShopCartList (state, item) { // 添加购物车商品
      if (state.shopcartlist.length == 0) { // 判断购物车列表是否为空
        for (var i = 0; i < item.length; i++) { // 购物车列表为空，直接添加进购物车
          state.shopcartlist.push(item[i])
        }
      } else { // 购物车列表不为空
        for (var j = 0; j < item.length; j++) {
          let sign = 0
          for (var i = 0; i < state.shopcartlist.length; i++) {
            if (state.shopcartlist[i].gg_id == item[j].gg_id) {
              state.shopcartlist[i] = item[j]
              sign = 1
            }
          }
          if (sign == 0) {
            state.shopcartlist.push(item[j])
          }
        }
      }
    },
    delShopCartList (state, ggid) { // 删除购物车商品
      for (var i = 0; i < ggid.length; i++) {
        for (var j = 0; j < state.shopcartlist.length; j++) {
          if (ggid[i] == state.shopcartlist[j].gg_id) {
            state.shopcartlist.splice(j, 1)
          }
        }
      }
    },
    numShopCartList (state, info) { // 购物车修改购买数量
      for (var i = 0; i < state.shopcartlist.length; i++) {
        if (state.shopcartlist[i].gg_id == info.ggid) {
          state.shopcartlist[i].num = info.num
          return false
        }
      }
    },
    remarksShopCartList (state, info) { // 购物车添加备注
      for (var i = 0; i < state.shopcartlist.length; i++) {
        if (state.shopcartlist[i].gg_id == info.ggid) {
          state.shopcartlist[i].remarks = info.remarks
          return false
        }
      }
    },
    againShopCartList (state, info) { // 订单详情再次购买
      state.shopcartlist = []
      state.shopcartlist = info
    },
  },
  actions: { // 应用mutations
    openmallFun ({commit}, sign) { // 修改主题色
      commit('openmallChange', sign)
    },
    requireAuthFun ({commit}, sign) { // 修改主题色
      commit('requireAuthChange', sign)
    },
    themecolorFun ({commit}, color) { // 修改主题色
      commit('sethemecolor', color)
    },
    addgoodsidFun ({commit}, id) { // 添加商品浏览记录
      commit('setgoodsid', id)
    },
    addShopCartList ({commit}, item) { // 添加购物车
      commit('setShopCartList', item)
    },
    delShopCartListFun ({commit}, ggid) { // 删除购物车
      commit('delShopCartList', ggid)
    },
    numShopCartListFun ({commit}, info) { // 购物车修改购买数量
      commit('numShopCartList', info)
    },
    remarksShopCartListFun ({commit}, info) { // 购物车添加备注
      commit('remarksShopCartList', info)
    },
    againShopCartListFun ({commit}, info) { // 订单详情再次购买
      commit('againShopCartList', info)
    }
  },
  plugins: [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store.js